(function($) {
if ($('.hv-block').length) {
	var mobile = false;
	if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
		mobile = true;
	}

	$(document).ready(function(){
		blockHeight();
	});

	$(window).load(function(){
		blockHeight();
	});

	$(window).resize(function(){
		blockHeight();
	});

	$(window).on('blockHeight',blockHeight);

	function blockHeight() {
		if (!mobile && $('body').prop('clientWidth')>=1024) {
			var blocks = $('.hv-block');
			blocks.each(function(){
				var images = $(this).find('.hv-block__main__images .img');
				// adjusting spacing
				if (images.length > 1 && $(window).outerWidth()>640) { //if there's only one image or we're in mobile, don't worry about it
					var addPadding		= 0;
					var staticImg 		= images.eq(0);
					var staticQuote		= $(this).find('.hv-block__quote');
					var staticBot 		= staticImg.offset().top + staticImg.outerHeight();
					if (staticQuote.length) {
						staticBot += staticQuote.outerHeight();
					}
					var firstFloatImg	= images.eq(1);
					var firstFloatBot 	= firstFloatImg.offset().top + firstFloatImg.outerHeight();
					if (firstFloatBot > staticBot) {
						addPadding = firstFloatBot - staticBot;
					}
					if (images.length > 2) {
						var secondFloatImg	= images.eq(2);
						var secondFloatBot 	= secondFloatImg.offset().top + secondFloatImg.outerHeight();
						if (secondFloatBot > staticBot) {
							addPadding = secondFloatBot - staticBot;
						}
					}
					if (addPadding > 0) {
						$(this).css('padding-bottom',addPadding);
					}
				} else {
					$(this).css('padding-bottom','');
				}
				// adjusting height if on tablet only
				if ($(window).outerWidth()<1024 && $(window).outerWidth()>640) {
					// get height of text block
					var textBlockHeight = $('.hv-block__main__text').outerHeight();
					// check if the main image is smaller than text, if so, increase height of main image
					if (textBlockHeight+60 > images.eq(0).outerWidth()*0.9) {
						images.eq(0).css('height',textBlockHeight+'px').css('padding','30px 0');
					} else {
						images.eq(0).css('height','auto').css('padding','90% 0 0 0');
					}
				} else {			
					images.eq(0).css('height','auto').css('padding','');
				}		
			});
		}
	}
}
})( jQuery );  